import React from "react";
import UserSummary from "../components/userSummary";

const Profile = () => {
	return <UserSummary forceRefreshAuthSession={true} />;
};

export default Profile;
